__turbopack_context__.v({
  "className": "zgcvEa_className",
  "variable": "zgcvEa_variable",
});
